import React, { useState, useEffect } from "react";
//Styles
import "../../../../assets/css/buscar-prenda.css";
//Components
import Table from "../../../tableSections/Table";
import Loading from "../../../tableSections/Loading";
import ModalGetProvince from "../../../modal/ModalGetProvince";
//Router
import { useParams } from "react-router-dom";
//Cookie token
import cookie from "react-cookies";
//GraphQL
import { useLazyQuery, gql } from "@apollo/client";
//Notifications
import { toast } from "react-toastify";
//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  loadOriginalResults,
  loadWorkResults,
  loadSettings,
  loadPaginatorItems,
  reloadResults,
} from "../../../../actions/tableDataActions";
//Utilities
import { getNewResults } from "../../../../utilities/provinces";
import {
  paginator,
  getPaginatorNavItems,
} from "../../../../utilities/paginator";

const ProvincesView = () => {
  const token = cookie.load("usertk"); // Used to redirect not logged in access attempts.
  let { id } = useParams();

  //Store data
  const { reload, search, filters, originalData, settings, orderBy } =
    useSelector((state) => state.dataTable);

  //States
  const [displayTable, setDisplayTable] = useState(false);

  //API
  const GET_PROVINCES = gql`
    query getProvinces {
      getProvinces (country_id: ${id}) {
        id
        name
      }
      getCountry (id: ${id}) {
        name
      }
    }
  `;

  const [getProvinces, { error, data }] = useLazyQuery(GET_PROVINCES);

  //Functions
  const goHome = () => {
    //Redirects if not logged in
    window.location.href = "/";
  };

  //Redux actions
  const dispatch = useDispatch();
  const storeOriginalLoad = () => dispatch(loadOriginalResults(data));
  const storeWorkLoad = (paginatedResults) =>
    dispatch(loadWorkResults(paginatedResults));
  const storeSettings = (defaultSettings) => dispatch(loadSettings(defaultSettings));
  const loadNewPaginatorItems = (paginatorItems) =>
    dispatch(loadPaginatorItems(paginatorItems));
  const storeReloadResults = (config) => dispatch(reloadResults(config));
  const loadNewResults = (newResults) => dispatch(loadWorkResults(newResults));

  //useEffect
  useEffect(() => {
    // Results without error
    if (data && !error) {
      //Section Settings
      const defaultSettings = {
        entity: "province",
        queryName: "getProvinces",
        title: `Lista de provincias de ${data.getCountry.name}`,
        text: "Puede utilizar el buscador para encontrar una provincia por su nombre.",
        createButtonText: "Crear Nueva Provincia",
        createButtonLink: "/provincias/crear-provincia/" + id,
        tableHeaders: [
          { text: "Nombre de la provincia", size: 75, orderBy: true, field: "name" },
          {
            text: "Opciones disponibles",
            size: 25,
            orderBy: false,
            field: "options",
          },
        ],
        searchLabel: "Buscar Provincia",
        paginationSettings: { page: 1, perPage: 6 },
        rowContent: [
          { size: 75, content: "name", align: "left" },
          {
            size: 25,
            buttons: [
              { text: "Ver", action: "modal", classes: "safe" },
              {
                text: "Editar",
                action: "link",
                link: "/provincias/editar-provincia",
                classes: "neutral",
              },
              { text: "Eliminar", action: "modal", classes: "unsafe" },
            ],
          },
        ],
      };
      storeSettings(defaultSettings);
      // Gets paginator items
      const paginatorItems = getPaginatorNavItems(
        data.getProvinces,
        defaultSettings.paginationSettings.perPage,
        defaultSettings.paginationSettings.page,
      );

      //Load work copy paginated
      let paginatedResults = {
        getProvinces: paginator(
          data.getProvinces,
          defaultSettings.paginationSettings.page,
          defaultSettings.paginationSettings.perPage
        ),
      };

      storeWorkLoad(paginatedResults); // Loads work copy in store
      //Load pagination items
      loadNewPaginatorItems(paginatorItems);

      // Loads original copy in store
      storeOriginalLoad(data);

      // Displays table
      setDisplayTable(true);
    } else if (data && data.getProvinces.length === 0) {
      // No results message display
      const Msg = ({ closeToast, toastProps }) => (
        <div>
          No existe ningún resultado.
          <br />
          <br />
          No existe todavía ninguna provinvia en este país o ninguna que coincida con la búsqueda.
        </div>
      );
      toast.error(<Msg />);
    } else if (error) {
      // Technical error display
      const Msg = ({ closeToast, toastProps }) => (
        <div>
          Se ha producido un error técnico
          <br />
          <br />
          Por favor, contacte con nosotros en el email que encontrará al pie de
          esta página.
        </div>
      );
      console.log(error);
      toast.error(<Msg />);
    }
  
    // eslint-disable-next-line
  }, [data, error]);

  useEffect(() => {
    //Generates new content and pagination
    if (reload) {
      //reset load flag to false to avoid loop
      storeReloadResults(false);

      // Gets new results
      const newResults = getNewResults(originalData, search, filters, orderBy);

      // Gets paginator items
      const paginatorItems = getPaginatorNavItems(
        newResults.getProvinces,
        settings.paginationSettings.perPage,
        settings.paginationSettings.page,
      );

      // Gets paginated results
      let paginatedResults = {
        getProvinces: paginator(
          newResults.getProvinces,
          settings.paginationSettings.page,
          settings.paginationSettings.perPage
        ),
      };
      //Load paginated results
      loadNewResults(paginatedResults);
      //Load pagination items
      loadNewPaginatorItems(paginatorItems);
    }
    // eslint-disable-next-line
  }, [reload]);

  useEffect(() => {
    //Runs query at first load
    getProvinces();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!token ? (
        goHome()
      ) : (
        <>
          <div className="table-container">
            <Loading />
            {displayTable && <Table />}
          </div>
          <ModalGetProvince />
        </>
      )}
    </>
  );
};

export default ProvincesView;
